import * as React from 'react';
import Svg from 'react-native-svg';
function Square(props) {
    return (React.createElement(Svg, { width: props.size, height: props.size, viewBox: '0 0 18 18', fill: 'none', xmlns: 'http://www.w3.org/2000/svg', ...props },
        React.createElement("rect", { x: '1', y: '1', width: '7', height: '7', rx: '0.5', stroke: props.color || '#667085' }),
        React.createElement("rect", { x: '10', y: '1', width: '7', height: '7', rx: '0.5', stroke: props.color || '#667085' }),
        React.createElement("rect", { x: '10', y: '10', width: '7', height: '7', rx: '0.5', stroke: props.color || '#667085' }),
        React.createElement("rect", { x: '1', y: '10', width: '7', height: '7', rx: '0.5', stroke: props.color || '#667085' })));
}
export default Square;
